import React, { useState, useEffect } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './react_dates_overrides.css';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import Modal from 'components/shared/modal';
import Icon from 'shared/icon';
import Button from 'shared/button';
import styles from './ticket-modal.module.scss';
import dates from './checkoutapi/format_dates';
import { callCheckout } from './checkoutapi';

function PurchaseModal({ setModalOff, opacity }) {
  const [date, setDate] = useState(moment());
  const [focused, setFocus] = useState(false);
  const [gen, setGen] = useState('');
  const [vip, setVip] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);
  const [submitReady, setSubmitReady] = useState(true);
  const [submitted, setSubmit] = useState(false);


  function handleChangeGen (value) {
    setGen(value);
    setSubmitReady(value !== '' || vip !== '');
  }

  function submit() {
    setSubmitReady(gen !== '' || vip !== '');
    setErrorMessage(gen === '' && vip === '');
  }

  function handleChangeVip (value) {
    setVip(value);
    setSubmitReady(gen !== '' || value !== '');
  }

  useEffect(() => {
    if (submitted && (gen || vip) && date) {
      const date_obj = dates[date.get().format('DD/MM/YYYY')];
      const [gen_v, vip_v] = date_obj.data;
      const ID = date_obj.id;
      const gen_id = gen_v.id;
      const vip_id = vip_v.id;

      callCheckout(
        {
          [gen_id]: {
            qty: gen
          },
          [vip_id]: {
            qty: vip
          }
        },
        ID
      ).then(checkoutresult => {
        setTimeout(() => {
          window.location.href = checkoutresult;
        }, 50);
      });
    }
  }, [date, gen, submitted, vip]);

  return (
    <Modal>
      <div
        className={`${styles.modalContainer} ${
          opacity ? styles.show : styles.hide
        }`}
      >
        <div className={styles.modalWrapper}>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={setModalOff}
          >
            <Icon icon="times" />
          </button>
          <div className={styles.modalContent}>
            <div className={styles.contentHeader}>
              <h2>THE ULTIMATE CANNABIS EXPERIENCE</h2>
              <h1>CANNABITION TICKETS</h1>
            </div>
            <p>Join us anytime during business hours</p>
            <form
              onSubmit={x => {
                setSubmit(true);
                x.preventDefault();
              }}
            >
              <SingleDatePicker
                date={date}
                onDateChange={setDate}
                focused={focused}
                onFocusChange={event => {
                  setFocus(event.focused);
                }}
                id="date-picker"
                inputIconPosition="after"
                noBorder
                showDefaultInputIcon
                numberOfMonths={1}
                displayFormat="dddd, MMMM Do YYYY"
                keepOpenOnDateSelect={false}
              />
              <div className={styles.inputGroup}>
                <p>HOW MANY TICKETS DO YOU NEED?</p>
              </div>
              <div className={styles.inputGroup}>
                <div className={`${styles.inputInline} ${styles.marginRight}`}>
                  <label htmlFor="general">General</label>
                  <select
                    val={gen}
                    onChange={x => handleChangeGen(x.target.value)}
                    // onChange={x => setGen(x.target.value)}
                    className={styles.inputField}
                    type="text"
                    autoComplete="off"
                    name="general"
                  >
                    <option value="">Select</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(number => (
                      <option value={number}>{number}</option>
                    ))}
                  </select>
                  <span className={styles.price}> x $24.20 </span>
                </div>
                <div className={styles.inputInline}>
                  <label htmlFor="VIP">
                    VIP
                    <span
                      className={styles.infoTag}
                      title="Private Tour and $10 towards any retail store merchandise"
                    >
                      &nbsp; <Icon icon="info" />
                    </span>
                  </label>
                  <select
                    value={vip}
                    onChange={x => handleChangeVip(x.target.value)}
                    // onChange={x => setVip(x.target.value)}
                    className={styles.inputField}
                    type="text"
                    autoComplete="off"
                    name="VIP"
                  >
                    <option value="">Select</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(number => (
                      <option value={number}>{number}</option>
                    ))}
                  </select>
                  <span className={styles.price}> x $42.00 </span>
                </div>
              </div>
              <p className={`${styles.errorMessage} ${errorMessage && styles.display}`} >Select the number of tickets before checking</p>
              <a
                className={styles.groupSale}
                href="https://cannabition.com/events/"
              >
                Click Here For Group Sales Information
              </a>
              <div className={styles.horizontalBar} />
              <div className={styles.inputGroup}>
                <Button
                  className={styles.submitBtn}
                  name="submit"
                  type="submit"
                  disabled={!submitReady}
                  onClick={submit}
                >
                  Checkout
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default PurchaseModal;
